import { EventHelper } from "app/helpers/eventHelper";
import AsianOdds from "app/screens/AsianEventsScreen/components/AsianOdds/AsianOdds";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import React from "react";
import "./AsianEventCellFirstLastGoal.scss";

const AsianEventCellFirstLastGoal = (
  props: Record<string, any>
): null | React.JSX.Element => {
  const { marketPeriods, event, addBetSlip } = props;
  const mrkt = get(marketPeriods, [[0], "marketTypes", [0], "markets", [0]]);

  if (!mrkt) {
    return null;
  }

  const groupedRunners = groupBy(mrkt.runners, "type");
  return (
    <div className="first-last-goal-container">
      <div className="first-last-goal-runners">
        {groupedRunners["FIRST_GOAL"] &&
          groupedRunners["FIRST_GOAL"].map(runner => {
            const highestOdds =
              runner &&
              runner["aggregatedPrices"] &&
              runner["aggregatedPrices"].length > 0 &&
              EventHelper.getHighestOddsValueFrom(runner["aggregatedPrices"]);
            return (
              <AsianOdds
                className={`${event["inRunning"] ? "asian-odds-live" : ""}`}
                odds={highestOdds}
                onClickPrice={() => addBetSlip(runner, props, event)}
                key={runner.id}
                runner={runner}
              />
            );
          })}
      </div>

      <div className="first-last-goal-runners">
        {groupedRunners["LAST_GOAL"] &&
          groupedRunners["LAST_GOAL"].map(runner => {
            const highestOdds =
              runner &&
              runner["aggregatedPrices"] &&
              runner["aggregatedPrices"].length > 0 &&
              EventHelper.getHighestOddsValueFrom(runner["aggregatedPrices"]);
            return (
              <AsianOdds
                className={`${event["inRunning"] ? "asian-odds-live" : ""}`}
                odds={highestOdds}
                onClickPrice={() => addBetSlip(runner, props, event)}
                key={runner.id}
                runner={runner}
              />
            );
          })}
      </div>

      <div className="first-last-goal-runners__no-goal">
        {groupedRunners["NO_GOAL"] &&
          groupedRunners["NO_GOAL"].map(runner => {
            const highestOdds =
              runner &&
              runner["aggregatedPrices"] &&
              runner["aggregatedPrices"].length > 0 &&
              EventHelper.getHighestOddsValueFrom(runner["aggregatedPrices"]);
            return (
              <AsianOdds
                className={`${event["inRunning"] ? "asian-odds-live" : ""}`}
                odds={highestOdds}
                onClickPrice={() => addBetSlip(runner, props, event)}
                key={runner.id}
                runner={runner}
              />
            );
          })}
      </div>
    </div>
  );
};

export default AsianEventCellFirstLastGoal;
